import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {engagementUserStatus} from '../../util/uiconstants';

export default function internalUsersReducer(state = initialstate.internalUsers, action) {
	switch (action.type) {
		case types.GET_INTERNAL_USERS: {
			if (!action) return state;
			if (action.response && action.response.users) {
				action.response.users.forEach(function(item) {
					item.isSelected = false;
				});
				return action.response;
			} else {
				return {fetchComplete: true};
			}
		}
		case types.ADD_INTERNAL_SELECTED_USER: {
			if (!action.user) return state;

			let newState = _.cloneDeep(state);

			let index = newState.users.findIndex((user) => user.userId === action.user);
			if (index !== -1) {
				newState.users[index].isSelected = true;
			}

			return newState;
		}
		case types.REMOVE_INTERNAL_SELECTED_USER: {
			if (!action.user) return state;

			let newState = _.cloneDeep(state);

			let index = newState.users.findIndex((user) => user.userId === action.user);
			if (index !== -1) {
				newState.users[index].isSelected = false;
			}

			return newState;
		}
		case types.CLEAR_INTERNAL_ALL_SELECTED_USERS: {
			let users = state.users.map((u) => {
				return {...u, isSelected: false};
			});

			return {...state, users};
		}
		case types.CLEAR_INTERNAL_USERS: {
			return {};
		}
		case types.PATCH_DEACTIVATE_USERS_LIST: {
			let users = state.users.map((u) => {
				if (action.userIds.some((userId) => userId.indexOf(u.userId) > -1)) {
					// update status of deactivated users
					return {...u, engagementUserStatusId: engagementUserStatus.DeActivated};
				}

				return u;
			});

			return {...state, users};
		}
		default:
			return state;
	}
}

export function internalUserReducer(state = initialstate.internalUser, action) {
	switch (action.type) {
		case types.GET_INTERNAL_USER_BY_ID: {
			return action.response;
		}
		case types.CLEAR_INTERNAL_USER: {
			return {};
		}
		default:
			return state;
	}
}

export function internalUserRbacRoleReducer(state = [], action) {
	switch (action.type) {
		case types.UPDATE_INTERNAL_USER_RBAC_ROLE_STATE: {
			return action.rbacRoles;
		}
		default:
			return state;
	}
}
